import SeoHead from "../components/SeoHead";
import { Global } from "@sourceflow-uk/sourceflow-sdk";
import "@sourceflow-uk/job-search/dist/bundle.css";
import React from "react";
import Header from '../components/MainHeader';
import NewSubBanner from "../components/NewSubBanner";
import InfoCards from "../components/InfoCardTab";
import MapSection from "../components/MapSection";
import KeyContactCards from "../components/KeyContactCards";
import SafetyTips from "../components/SafetyTips";
import GetHomeSafeFooter from "../components/GetHomeSafeFooter";

export default function SoreenPage({
  global,
  // sectorIds
}) {
  return (
    <>
      <SeoHead
        // site_name={`Driving Force`}
        page_name={`Find Work that suits you | Gap Personnel`}
        // description={`Check out all of our driving jobs including HGV vacancies. If you are looking for full-time, part-time or temporary driving jobs please contact us today.`}
        canonical_link={`/soreen`}
      />
      <Header
        employerNav={false}
      />
      <NewSubBanner
        global={global}
        pathPrefix={``}
        customClass={`mb-5 secondary-banner all-jobs-page`}
        heading={`Get home safe`}
        bannerImage="/site-assets/images/Soreen_banner.png"
        bannerImageAlt="Soreen Banner"
      />
      <InfoCards
        global={global}
        pathPrefix=""
        customClass="mt-1"
        heading={<h1>Your journey home matters to us.</h1>}
        paragraph1="Whether you’re on days or nights at Soreen, your journey home matters to us. We want you to feel safe getting to work and getting back home again."
        paragraph2="This page brings together everything you need to get home safe - travel options, key contacts and what to do if you ever feel unsure or unsafe."
        content={[
          {
            icon: "/site-assets/images/plan_your_journey.png",
            title: "Plan your journey",
            buttonTitle: "View travel info",
            buttonLink: "/soreen/#MapsSection",
            body: (
              <ul>
                <li>Check public transport times</li>
                <li>Plan your route home</li>
                <li>Arrange lifts if needed</li>
              </ul>
            ),

          },
          {
            icon: "/site-assets/images/need_help.png",
            title: "Need help?",
            buttonTitle: "View Contacts",
            buttonLink: "/soreen/#KeyContacts",
            body: (
              <ul>
                <li>Contact your shift manager</li>
                <li>Speak to site security</li>
                <li>Use emergency contacts</li>
              </ul>
            )
          },
          {
            icon: "/site-assets/images/safety_tips.png",
            title: "Safety tips",
            buttonTitle: "View Tips",
            buttonLink: "/soreen/#SafetyTips",
            body: (
              <ul>
                <li>Stay in well lit areas</li>
                <li>Travel with others when possible</li>
                <li>Report concerns immediately</li>
              </ul>
            )
          }
        ]}
      />

      <MapSection
        heading="Getting to and from Soreen"
        mapSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2375.2852239130452!2d-2.3277362229040475!3d53.463362465961175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487bae85b87d5c1f%3A0xa587b0cb7f892da9!2sSoreen!5e0!3m2!1sen!2smy!4v1773213633386!5m2!1sen!2smy"
        mapLink={'https://maps.app.goo.gl/M8AAZ4Sjk3RFkiRY7'}
        addressLine1="Marshall Stevens Way"
        addressLine2="Trafford Park"
        addressLine3="Stretford"
        addressLine4="Manchester"
        addressPostcode="M17 1PP"
        cards={[
          {
            icon: "/site-assets/images/buses.png",
            heading: "Bus Stops",
            subHeading: "Nearest bus stops",
            bulletPoints: [
              { label: "Textilose Road -", value: "about a 3 minute walk" },
              { label: "Westinghouse Road - ", value: "about  a 6 - minute walk" },
            ],
            buslines: "248 / 250 / 150",
            bottomText: "Link to Trafford Centre and Manchester City centre"
          },
          {
            icon: "/site-assets/images/tram.png",
            heading: "Tram",
            subHeading: "ParkAway (Red line) - about a 12 minute walk",
            bulletPoints: [
              { label: "To Manchester city center", value: "" },
              { label: "To Trafford Centre", value: "" },
            ],
            bottomText: "Always check the live times on the Bee Network or TFGM"
          }
        ]}
        TransportCardBtn={true}
        TransportCardLink="https://tfgm.com/plan-a-journey"
        TransportCardBtnText={'Bee Network'}
        bottomCard={false}
        bottomCardText='Always check the latest travel times and stop info before you travel using the Warrington’s Own Buses journey planner . '
      />

<KeyContactCards
  card1Items={[
    {
      logo: "/site-assets/images/Soreen_key_contact.png",
      title: "Soreen",
      bulletPoints: [
        { label: <><span>Phone </span> - <a href="tel:01618744100" className="bullet-link"><strong>0161 874 4100</strong></a></> },
        { label: <><span>Hours </span> - <strong>Open 24 Hours</strong></> },
      ]
    },
    {
      logo: "/site-assets/images/gap_personnel_key_contact.png",
      title: "gap personnel",
      bulletPoints: [
        { label: <><span>Magdalena Danda</span> - <a href="tel:07885466171" className="bullet-link"><strong>07885 466171</strong></a></> },
        { label: <><span>Melissa McDarby</span> - <a href="tel:07885968967" className="bullet-link"><strong>07885 968967</strong></a></> },
        { label: <><span>Andrew Spice</span> - <a href="tel:07740824842" className="bullet-link"><strong>07740 824842</strong></a></> },
      ]
    }
  ]}
  logo1="/site-assets/images/emergency_key_contacts.png"
  logo2="/site-assets/images/ice_key_contacts.png"
/>

      <SafetyTips 
      card1={
        <>
          <h5>Buddy system and check-ins</h5>
          <ul>
            <li>Travel with someone from your shift where possible</li>
            <li>Tell someone when you’re leaving work</li>
            <li>Let them know your route and expected time home</li>
            <li>Send a quick message when you arrive safely</li>
          </ul>
        </>
      } 
      logo1={'/site-assets/images/safety_tips.png'}
      singleLine1={'Only buddy up with people you’re comfortable with - it’s always your choice.'}
      logo2={'/site-assets/images/stay_aware.png'}
      singleLine2={'Shops, petrol stations and transport hubs are good safe spaces.'}
      card2={
        <>
          <h5>Stay aware on your journey</h5>
          <ul>
            <li>Stick to well - lit, busy routes</li>
            <li>Avoid shortcuts through quiet areas</li>
            <li>Keep your phone use to a minimum while walking</li>
            <li>If something feels off, change direction or head somewhere public</li>
          </ul>
        </>
      } 
      card3={
        <>
          <h5>Travel smart, arrive safely</h5>
          <ul>
            <li>Share your location with someone you trust if needed</li>
            <li>Text or message rather than calling if you’re in a quiet area</li>
            <li>Have your keys ready before you reach your door</li>
            <li>Take a quick look around before going inside</li>
            <li>Lock the door as soon as you’re in</li>
          </ul>
        </>
      } 
      logo3={'/site-assets/images/travel_smart.png'}
      />

      <GetHomeSafeFooter />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = await Global();
  return {
    props: {
      global: global.toJson(),
      // sectorIds
    },
  };
}